<div>

  <div class="field">
    <p-table [value]="etapaProyectoTramite || []"
             [scrollable]="true"
             scrollHeight="250px"
             styleClass="p-datatable-striped p-datatable-sm">

      <ng-template pTemplate="header">
        <tr>
          <th>Etapa</th>
          <th>Meses</th>
          <th>Trámite</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-etapa>
        <tr>
          <td>{{ etapa.numeroEtapa }}</td>
          <td>{{ etapa.cantidadMeses }}</td>
          <td>{{ etapa.tramite?.nombreTramite }}</td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>
